module.exports = __webpack_public_path__ + "media/images/mobile/home/banner5-abea28568711aeb6fb55bc3bace78c34.jpg";